import { showToast, clearToasts } from '../utils/useToast';
// Tasarım token'ları (global `:root`) ve bildirim CSS'i açılışta: giriş sayfasında da bildirim çıkar.
import '../assets/css/est-tokens.css';
import '../assets/css/toast.css';

/* Estesoft.App ToastPlugin'in Vega kopyası. Legacy toastr imzası korunur: (message, title, options);
   ikinci argüman nesneyse seçenek sayılır (ör. `{ timeOut: 0 }` kalıcı bildirim). */
function notify(type) {
  return (message, title, options) => {
    const isOptions = title && typeof title === 'object';
    showToast({
      message,
      title: isOptions || typeof title !== 'string' ? '' : title,
      type,
      ...(isOptions ? title : options || {})
    });
  };
}

export default {
  install(app) {
    app.config.globalProperties.$toastr = {
      success: notify('success'),
      error: notify('danger'),
      warning: notify('warning'),
      info: notify('info'),
      clear: clearToasts,
      remove: clearToasts
    };
  }
};
